export default __webpack_public_path__ + "static/media/program_intro_4.af1ec2d4.png";